ModalGallery = require('./../ModalGallery');

class Gallery {

    constructor(element, data) {
        this.data = data;
        window.data = data;
        this.initElements(element);
        this.modalGallery = new ModalGallery({
            data,
            filterItems: ($element, data) => {
                return this.selectedItems;
                return data.filter(item => this.selectedItems.indexOf(item) != -1);
                //console.log("---->", data, this.selectedItems);
                let options = [];
                this.$galleryConainer.find('a:visible').each((i, a) => {
                    console.log(a);
                    options.push(data[a.dataset.index]);
                });
                return options;
            },
            checkVideo: ($elem, modalGallery) => {
                if (this.selectedItems[$elem.data('index')].video) {
                    modalGallery.autoPlay = true;
                }
            }
        });
        this.initEvents();
        this.renderGalery();
    }

    static init(element, data) {
        new Gallery(element, data);

        if (section != '') {
            var clickIn = section;

            if (section == 'interior') {
                clickIn = 'showInside';
            } else if (section == 'exterior') {
                clickIn = 'showOutside';
            } else {
                clickIn = 'showVideo';
            }

            console.log(clickIn);
            $('.' + clickIn).trigger('click');
        }
    }

    templateThreeElementsA(currentItem, item1, item2, item3) {
        return $(`
            <div class="col-12 col-lg-8 p-0 gallery" >
                <a
                    data-index="${currentItem}"
                    href="${item1.image}"
                >
                    ${item1.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                    <img src="${item1.thumbnail}" style="width:100%" alt="${item1.description}"/>
                </a>
            </div>
            <div class="col-12 col-lg-4 gallery">
                <div class="row">
                    <div class="col col-lg-12 p-0">
                        <a
                            data-index="${currentItem + 1}"
                            href="${item2.image}"
                        >
                            ${item2.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                            <img src="${item2.thumbnail}" style="width:100%"  alt="${item2.description}"/>
                        </a>
                    </div>
                    <div class="col col-lg-12 p-0">
                        <a
                            data-index="${currentItem + 2}"
                            href="${item3.image}"
                        >
                            ${item3.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                            <img src="${item3.thumbnail}" style="width:100%"  alt="${item3.description}"/>
                        </a>
                    </div>
                 </div>
            </div>
        `);
    }

    templateThreeElementsB(currentItem, item4, item5, item6) {
        return $(`
        <div class="col-12 col-lg-4 gallery">
            <div class="row">
                <div class="col col-lg-12 p-0">
                    <a
                        data-index="${currentItem}"
                        href="${item4.image}"
                    >
                        ${item4.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                        <img src="${item4.thumbnail}" style="width:100%"  alt="${item4.description}"/>
                    </a>
                </div>
                <div class="col col-lg-12 p-0" style="height:100px">
                    <a
                        data-index="${currentItem + 1}"
                        href="${item5.image}"
                    >
                         ${item5.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                        <img src="${item5.thumbnail}" style="width:100%"  alt="${item5.description}"/>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-8 p-0 gallery">
            <a
                data-index="${currentItem + 2}"
                href="${item6.image}"
            >
                ${item6.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                <img src="${item6.thumbnail}" style="width:100%"  alt="${item6.description}"/>
            </a>
        </div>`);
    }

    templateTwoElements(currentItem, item7, item8) {
        return $(`
            <div class="col gallery" >
                <div class="row">
                    <div class="col-6  col-lg-4 p-0">
                        <a
                            data-index="${currentItem}"
                            href="${item7.image}"
                        >
                            ${item7.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                            <img src="${item7.thumbnail}" style="width:100%"  alt="${item7.description}"/>
                        </a>
                    </div>
                    <div class="col-6  col-lg-4 p-0">
                        <a
                            data-index="${currentItem + 1}"
                            href="${item8.image}"
                        >
                            ${item8.category == 'video' ? '<div class="video-btn align-items-center"></div>' : ''}
                            <img src="${item8.thumbnail}" style="width:100%"  alt="${item8.description}"/>
                        </a>
                    </div>
                </div>
            </div>
        `);
    }

    templateOneElement(currentItem, item9) {
        return $(`<div class="col-12 col-lg-8 p-0 gallery" >
                <a
                    data-index="${currentItem}"
                    href="${item9.image}"
                >
                    ${item9.video ? '<div class="video-btn align-items-center"></div>' : ''}
                    <img src="${item9.thumbnail}" style="width:100%" alt="${item9.description}"/>
                </a>
            </div>`);
    }

    initElements(element) {
        this.$rootElement = $(element);
        this.$galleryMenu = this.$rootElement.find('.gallery-menu');
        this.$galleryConainer = this.$rootElement.find('.gallery-container');
        this.$galleryConainer.empty();
    }

    renderGalery(gallery = 'all') {
        const items = gallery == 'all' ? this.data : this.data.filter((item, i) => {
            if (gallery === 'video' && item.category == 'video') {
                return item;
            } else if (item.category === gallery) {
                return item;
            }
        });
        this.selectedItems = items;
        this.modalGallery.setData(items);
        let numberItems = items.length;
        let i = 0;
        let currentItem = 0;
        $fragment = $(document.createDocumentFragment());
        do {
            if (numberItems >= 3) {
                $fragment.append(
                    this[`templateThreeElements${i % 2 ? 'B' : 'A'}`](currentItem,
                        items[currentItem++],
                        items[currentItem++],
                        items[currentItem++]));
                numberItems -= 3;
                i++;
            } else if (numberItems == 2) {
                $fragment.append(this.templateTwoElements(currentItem,
                    items[currentItem++],
                    items[currentItem++]
                ))
                numberItems -= 2;
            } else if (numberItems) {
                $fragment.append(this.templateOneElement(currentItem, items[currentItem++]))
                numberItems--;
            }
        } while (numberItems)
        this.$galleryConainer.append($fragment);
    }

    initEvents() {
        this.$galleryMenu
            .on('click', 'a', this.onClickMenuBtn.bind(this))
            .on('click', 'a.showAll', () => this.showGallery('all'))
            .on('click', 'a.showInside', () => this.showGallery('inside'))
            .on('click', 'a.showOutside', () => this.showGallery('outside'))
            .on('click', 'a.showVideo', () => this.showGallery('video'))
        ;
        this.$galleryConainer.on('click', 'a', this.showModal());
    }

    showModal() {
        let gallery = this;
        return function (e) {
            e.preventDefault();
            gallery.modalGallery.show($(this));
        }
    }

    showGallery(subgallery = false) {
        $('.gallery').hide('fast').promise().done(() => {
            this.$galleryConainer.empty();
            this.renderGalery(subgallery);
            this.$galleryConainer.slideDown();
        })

        /*subgallery ? $('.gallery').hide('fast').promise().done(() => {
            $(subgallery).show('fast');
        }) : $('.gallery').show('fast');
        */
    }

    onClickMenuBtn(e) {
        e.preventDefault();
        this.$galleryMenu.find('.active').removeClass('active');
        $(e.target).closest('li').addClass('active');
    }

}

module.exports = Gallery;
